import axios from "axios";
import Vue from "vue";
import router from "../router";


const apiClientLogin = axios.create({
  baseUrl: "http://localhost:3000",
  withCredentials: false,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json"
  }
})
const url = "https://www.wohnungsdatenbank.uni-freiburg.de/backend/User/";

export default {
  login(username, password) {

        return apiClientLogin.get(url + "user.php",{
          withCredentials: false,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          },
          params: {
            email: username,
            password: password
          },
          method: "POST"
        })

  },
  register(user){
    if(user.type == 1){
      return apiClientLogin.get(url + "createSuchendenAccount.php",{
        params: {
          vorname: user.vorname,
          nachname: user.nachname,
          email: user.email,
          password: user.password,
          passwordConfirmation: user.password_confirmation,
          status: user.status,
          institution: user.institution,
          institutionuntergruppe: user.institutionuntergruppe,
          country: user.country,
          aufenthaltvon: user.aufenthaltVon,
          aufenthaltbis: user.aufenthaltBis,
          geschlecht: user.geschlecht,
          mitfamilie: user.mitfamilie,
          sonstiges: user.sonstiges,
          nationalitaet: user.nationalitaet,
          expirationdate: user.expirationdate,
          activationhash: user.activationhash
        }
    })
    } else {
      return apiClientLogin.get(url + "createVermieterAccount.php",{
        params: {
          user: JSON.stringify(user)
        }
    })
    }

  },
  logout() {
    router.push("/login");
  },
  confirmPolicy(id){
    return apiClientLogin.get(url + "confirmPolicy.php", {
      params: {
        id: id,
      }
    });
  },
  setUserSystemMailStatus(email){
    return apiClientLogin.get(url + "setUserSystemMailStatus.php", {
      params: {
        email: email
      }
    });
  },
  getUser(user){
      let getUser = user;
      if(typeof(getUser) === "string" || getUser instanceof String){
        let user =  JSON.parse(getUser);
        return user;
      } else {

        return getUser;
      }
  },
  editUserSuchender(user){
    return apiClientLogin.get(url + "editUserSuchender.php", {
      params: {
        user: JSON.stringify(user)
      }
    });
  },
  editUserVermieter(user){
    return apiClientLogin.get(url + "editUserVermieter.php", {
      params: {
        user: JSON.stringify(user)
      }
    });
  },
  deleteUserVermieter(account, id){
    return apiClientLogin.get(url + "deleteUserVermieter.php", {
      params: {
        account: account,
        vermieterid: id
      }
    });
  },
  deleteUserMieter(account){
    return apiClientLogin.get(url + "deleteUserMieter.php", {
      params: {
        account: account,
      }
    });
  },
  resetUserPassword(email, hash){
    return apiClientLogin.get(url + "resetUserPassword.php", {
      params: {
        email: email,
        hash: hash,
      }
    });
  },
  resetPassword(hash, pw){
    return apiClientLogin.get(url + "resetPassword.php", {
      params: {
        hash: hash,
        pw: pw
      }
    });
  },
  searchMieterLogin(email){
    return apiClientLogin.get(url + "findSuchendenLogin.php", {
      params: {
        email: email,
      }
    });
  },
  searchVermieter(parameter, searchfor = 1){
    if(searchfor != 1){
      return apiClientLogin.get(url + "findVermieter.php", {
        params: {
          vermieter: parameter,
        }
      });
    } else{
      return apiClientLogin.get(url + "findVermieter.php", {
        params: {
          email: parameter,
        }
      });
    }

  },
  searchMieter(email){
    return apiClientLogin.get(url + "findMieter.php", {
      params: {
        email: email,
      }
    });
  },
  getSuchendeLogins(email){
    return apiClientLogin.get(url + "findSuchendenLogin.php", {
      params: {
        email: email,
      }
    });
  },
  getVermieterLogins(email){
    return apiClientLogin.get(url + "findVermieterLogin.php", {
      params: {
        email: email,
      }
    });
  },
  getUserToActivate(){
    return apiClientLogin.get(url + "getUserToActivate.php", {})
  },
  activateUser(id, hash, type){
    return apiClientLogin.get(url + "activateUser.php", {
      params: {
        id: id,
        activationHash: hash,
        type: type
      }
    });
  },
  declineUser(id, hash, type){
    return apiClientLogin.get(url + "activateUserDecline.php", {
      params: {
        id: id,
        activationHash: hash,
        type: type
      }
    });
  },

  validateEmail(email){
    return apiClientLogin.get(url + "validateEmail.php", {
      params:{
        email: email
      }
    })
  },
  getAllUsers(){
    return apiClientLogin(url + "getAllUser.php", {
      params: {
        token: '5478c10ffea156cbc10d959033805d8d'
      }
    })
  }
};
